/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "description-4f32abe7--sprite",
  "use": "description-4f32abe7--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"description-4f32abe7--sprite\"><rect width=\"36\" height=\"36\" fill=\"none\" /><g transform=\"translate(-851.35 -4350.451)\"><g transform=\"translate(860.698 4358.114)\"><path d=\"M872.823,4373.646l-.669,2.391a.561.561,0,0,0,.54.708.671.671,0,0,0,.152-.017l2.391-.669a.6.6,0,0,0,.242-.146l8.37-8.37c.011-.005.017-.017.028-.022a.221.221,0,0,1,.039-.039l.473-.479a1.256,1.256,0,0,0,.079-1.783l-.8-.8a.1.1,0,0,0-.028-.022,1.24,1.24,0,0,0-1.732.074l-4.455,4.455h-7.976a1.506,1.506,0,0,0-1.5,1.508v9.584a1.51,1.51,0,0,0,1.5,1.508h13.2a1.516,1.516,0,0,0,1.508-1.508v-9.472a.563.563,0,0,0-1.125,0v9.472a.387.387,0,0,1-.383.383h-13.2a.382.382,0,0,1-.377-.383v-9.584a.382.382,0,0,1,.377-.383h6.846l-3.353,3.353A.547.547,0,0,0,872.823,4373.646Zm9.894-8.4a.116.116,0,0,1,.163-.017l.771.765c.045.05.039.129-.034.2l-.141.141-.923-.923Zm-8.854,8.849,7.9-7.892.922.922-7.892,7.892-1.282.359Z\" transform=\"translate(-867.969 -4364.075)\" fill=\"currentColor\" /></g></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
